import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ClusterHttpService} from './cluster-http.service'
import {ICluster} from '../interfaces'
import {tap} from "rxjs/operators";

@Injectable()
export class ClusterService {
    private clusterSubject: BehaviorSubject<ICluster[]> = new BehaviorSubject<ICluster[]>([]);
    public cluster$: Observable<ICluster[]> = this.clusterSubject.asObservable()

    constructor(private clusterHttp: ClusterHttpService) {
    }

    public getCluster(): Observable<ICluster[]> {
        return this.clusterHttp.getCluster()
            .pipe(
                tap(cluster => {
                    this.clusterSubject.next(cluster);
                })
            )
    }
}
